import {
    requestGetProviderCategories,
    requestGetproviderSearchData,
    requestGetproviderSearchDataWithToken
} from '../requests/provider';
import { call, put, select } from "redux-saga/effects";
import { setProviderCategoryData, setProviderSearchData, setLoaderState } from '../../duck/provider';
import { setAuthData } from '../../duck/auth';

export function* handleGetProviderCategory(action) {
    try {
        yield put(setLoaderState(true));
        const response = yield call(requestGetProviderCategories);
        const { data } = response;
        yield put(setProviderCategoryData([...data]));
        yield put(setLoaderState(false));
    } catch (error) {
        yield put(setLoaderState(false));
    }
}

export function* handleGetProviderSearchData(action) {
    try {
        yield put(setProviderSearchData({}));
        yield put(setLoaderState(true));
        const { isAuthenticated } = yield select((state => state.auth));
        if(!isAuthenticated)
        {
            const response = yield call(requestGetproviderSearchData, action.payload);
            const { data } = response;
            yield put(setProviderSearchData({ ...data.item }));
        }
        else{
            const response = yield call(requestGetproviderSearchDataWithToken, action.payload);
            const { data } = response;
            yield put(setProviderSearchData({ ...data.item }));
        }
        yield put(setLoaderState(false));
    } catch (error) {
        if(error.response.status === 401)
            yield put(setAuthData(false));
        yield put(setLoaderState(false));
    }
}
